import { SchemaValidation } from 'utilities/validationCheck'
import { i18n } from '@lingui/core'
import { t } from '@lingui/macro'

export const categoryFormSchema = SchemaValidation.object().shape({
  name: SchemaValidation.string()
    .min(3, i18n._(t`Panjang minimal karakter adalah 3`))
    .required(i18n._(t`Nama Kategori tidak boleh kosong`)),
})
